import { useState, useEffect, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import AuthContext from '../context/AuthContext';
import config from '../config';

const Home = () => {
    const { user } = useContext(AuthContext);
    const navigate = useNavigate();
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchBlogs();
    }, []);

    const fetchBlogs = async () => {
        try {
            const res = await axios.get(`${config.API_URL}/blogs`);
            setBlogs(res.data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching blogs:', error);
            setLoading(false);
        }
    };

    const handleDelete = async (blogId) => {
        if (!window.confirm('Are you sure you want to delete this blog post?')) {
            return;
        }

        try {
            const token = localStorage.getItem('token');
            await axios.delete(`${config.API_URL}/blogs/${blogId}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setBlogs(blogs.filter(blog => blog.id !== blogId));
            alert('Blog post deleted successfully!');
        } catch (error) {
            console.error('Error deleting blog:', error);
            alert('Failed to delete blog post. Please try again.');
        }
    };

    const handleEdit = (slug) => {
        navigate(`/edit-post/${slug}`);
    };

    if (loading) {
        return <div className="container">Loading...</div>;
    }

    return (
        <div className="blog-page" style={{ backgroundColor: '#fbf5ec', minHeight: '100vh', paddingTop: '2rem', paddingBottom: '4rem' }}>
            <div className="container">
                {user && (
                    <Link to="/create-post" className="floating-action-btn">
                        + Create Post
                    </Link>
                )}

                <div className="shop-header">
                    <h1>Chess Blog</h1>
                    <p>Insights, strategies, and stories from the chess world</p>
                </div>

                {blogs.length === 0 ? (
                    <div className="no-products">
                        <p>No blog posts yet. Be the first to create one!</p>
                    </div>
                ) : (
                    <div className="product-grid">
                        {blogs.map(blog => (
                            <div key={blog.id} className="blog-card">
                                {/* Edit/Delete Buttons - Only visible to logged-in users */}
                                {user && (
                                    <div className="card-actions">
                                        <button
                                            className="action-btn edit-btn"
                                            onClick={() => handleEdit(blog.slug)}
                                            title="Edit"
                                        >
                                            ✏️
                                        </button>
                                        <button
                                            className="action-btn delete-btn"
                                            onClick={() => handleDelete(blog.id)}
                                            title="Delete"
                                        >
                                            🗑️
                                        </button>
                                    </div>
                                )}

                                <div className="blog-card-content">
                                    <h3 className="blog-title">
                                        <Link to={`/post/${blog.slug}`}>{blog.title}</Link>
                                    </h3>

                                    {blog.excerpt && (
                                        <p className="blog-description">
                                            {blog.excerpt}
                                        </p>
                                    )}

                                    <p className="blog-meta">
                                        <span className="blog-author">By {blog.author.username}</span>
                                        <span className="blog-date">{new Date(blog.createdAt).toLocaleDateString()}</span>
                                    </p>

                                    <div className="blog-card-footer">
                                        <Link to={`/post/${blog.slug}`} className="btn-read-more">
                                            Read More →
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Home;
